import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import _cloneDeep from 'lodash/cloneDeep';
import MenuItem from '@mui/material/MenuItem';
import { comparisonParams, filterParams } from '../../../utils/segments';
import { addQueryParams } from '../../../utils/browser';
import ReduxStore from 'src/types/store/reduxStore';
import _pick from 'lodash/pick';
import { AdEntityEntity } from 'sl-api-connector';

const mapStateToProps = (state: ReduxStore) =>
  _pick(state, ['app', 'adEntities', 'categories', 'entityService', 'retailer', 'mainTimePeriod']);

type Props = ReturnType<typeof mapStateToProps> &
  RouteComponentProps & {
    searchText: string;
    togglePanel?: () => {};
  };

class Entities extends React.Component<Props> {
  public state: {
    entities: AdEntityEntity[];
  } = { entities: [] };

  componentWillMount() {
    const { adEntities } = this.props;
    const entities = _cloneDeep(adEntities);

    this.setState({ entities });
  }

  componentWillReceiveProps(nextProps) {
    const { searchText, adEntities } = nextProps;

    const filteredEntities = adEntities.filter(
      (val) => val.displayName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    this.setState({
      entities: filteredEntities
    });
  }

  handleTouchTap = (selection) => {
    const { togglePanel, location, retailer, mainTimePeriod } = this.props;
    const entity = {
      id: selection.id,
      type: 'adEntity'
    };

    const existingParams = addQueryParams(location, retailer, mainTimePeriod, [...filterParams, ...comparisonParams]);

    togglePanel();
    this.props.history.push(`?ctype=${entity.type}&cid=${entity.id}&${existingParams}`);
  };

  showNoEntities() {
    const { entities } = this.state;

    if (entities.length > 0) {
      return null;
    }

    return <div style={{ padding: '10px' }}>No entities found.</div>;
  }

  render() {
    const { entities } = this.state;
    return (
      <div style={{ padding: '10px' }}>
        {entities.map((val) => (
          <MenuItem key={val.entityId} style={{ fontSize: '14px' }} onClick={() => this.handleTouchTap(val)}>
            {val.displayName}
          </MenuItem>
        ))}
        {this.showNoEntities()}
      </div>
    );
  }
}

export default withRouter(connect((state) => state)(Entities));
